import { api } from "./client";

const resource = (base) => ({
  list: (query) => api(base, { query }),
  get: (id, query) => api(`${base}/${id}`, { query }),
  create: (body) => api(base, { method: "POST", body }),
  update: (id, body) => api(`${base}/${id}`, { method: "PATCH", body }),
  remove: (id) => api(`${base}/${id}`, { method: "DELETE" }),
});

export const expensesApi = {
  ...resource("/expenses"),
  settle: (id, body) => api(`/expenses/${id}/settle`, { method: "POST", body }),
  statement: (id, query) => api(`/expenses/${id}/statement`, { query }),
};
export const projectsApi = {
  ...resource("/projects"),
  khata: (id, query) => api(`/projects/${id}/khata`, { query }),
  statement: (id, query) => api(`/projects/${id}/statement`, { query }),
};
export const buildersApi = resource("/builders");
export const banksApi = resource("/banks");
export const logsApi = { list: (query) => api("/logs", { query }) };

export const vendorsApi = {
  ...resource("/vendors"),
  khata: (id, query) => api(`/vendors/${id}/khata`, { query }),
  udhar: (query) => api("/vendors/udhar", { query }),
  udharExpenses: (id, query) => api(`/vendors/${id}/udhar-expenses`, { query }),
  statement: (id, query) => api(`/vendors/${id}/statement`, { query }),
  settle: (id, body) => api(`/vendors/${id}/settle`, { method: "POST", body }),
};

export const salesApi = {
  ...resource("/sales"),
  statement: (id, query) => api(`/sales/${id}/statement`, { query }),
  updatePlan: (saleId, body) => api(`/sales/${saleId}/plan`, { method: "PATCH", body }),
  addInstallment: (saleId, body) => api(`/sales/${saleId}/installments`, { method: "POST", body }),
  updateInstallment: (saleId, installmentId, body) =>
    api(`/sales/${saleId}/installments/${installmentId}`, { method: "PATCH", body }),
  removeInstallment: (saleId, installmentId) =>
    api(`/sales/${saleId}/installments/${installmentId}`, { method: "DELETE" }),
};

export const ledgerApi = {
  today: (query) => api("/ledger/today", { query }),
  list: (query) => api("/ledger", { query }),
  byDate: (date, query) => api(`/ledger/${date}`, { query }),
  month: (month, query) => api(`/ledger/month/${month}`, { query }),
  statement: (query) => api("/ledger/statement", { query }),
  dailyStatement: (date, query) => api(`/ledger/${date}/statement`, { query }),
  setOpening: (body) => api("/ledger/opening-balance", { method: "POST", body }),
  endDay: () => api("/ledger/day-end", { method: "POST" }),
};

export const unwrap = (res) => res?.data ?? null;
export const unwrapList = (res) => ({
  items: res?.data?.items || [],
  pagination: res?.data?.pagination || { page: 1, totalPages: 1, total: 0 },
  khata: res?.data?.khata ?? null,
});
